module.exports = __webpack_public_path__ + "static/media/dpex.c0065ac8.svg";